import { render, staticRenderFns } from "./SettingsContentAppearance.vue?vue&type=template&id=9c4341ec&scoped=true&"
import script from "./SettingsContentAppearance.vue?vue&type=script&lang=js&"
export * from "./SettingsContentAppearance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4341ec",
  null
  
)

export default component.exports